export default __webpack_public_path__ + "/dist/images/4247488.11f1303b8b4de354cc47f36395a2d50c.png";